import createIcon from '../../createIcon';

/**
 * @component @name ChildFriendly
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuNSAyVjEwSDIxLjVDMjEuNSA1LjU4IDE3LjkyIDIgMTMuNSAyWk0xOS44MiAxNS44OUMyMC44NyAxNC41NCAyMS41IDEyLjg0IDIxLjUgMTFINi45NEw1Ljk5IDlIMi41VjExSDQuNzJDNC43MiAxMSA2LjYxIDE1LjA3IDYuODQgMTUuNDJDNS43NCAxNi4wMSA1IDE3LjE3IDUgMTguNUM1IDIwLjQzIDYuNTcgMjIgOC41IDIyQzEwLjI2IDIyIDExLjcyIDIwLjcgMTEuOTYgMTlIMTQuMDRDMTQuMjggMjAuNyAxNS43NCAyMiAxNy41IDIyQzE5LjQzIDIyIDIxIDIwLjQzIDIxIDE4LjVDMjEgMTcuNDYgMjAuNTQgMTYuNTMgMTkuODIgMTUuODlaTTguNSAyMEM3LjY3IDIwIDcgMTkuMzMgNyAxOC41QzcgMTcuNjcgNy42NyAxNyA4LjUgMTdDOS4zMyAxNyAxMCAxNy42NyAxMCAxOC41QzEwIDE5LjMzIDkuMzMgMjAgOC41IDIwWk0xNy41IDIwQzE2LjY3IDIwIDE2IDE5LjMzIDE2IDE4LjVDMTYgMTcuNjcgMTYuNjcgMTcgMTcuNSAxN0MxOC4zMyAxNyAxOSAxNy42NyAxOSAxOC41QzE5IDE5LjMzIDE4LjMzIDIwIDE3LjUgMjBaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ChildFriendly = createIcon('ChildFriendly', [
  [
    'path',
    {
      d: 'M13.5 2V10H21.5C21.5 5.58 17.92 2 13.5 2ZM19.82 15.89C20.87 14.54 21.5 12.84 21.5 11H6.94L5.99 9H2.5V11H4.72C4.72 11 6.61 15.07 6.84 15.42C5.74 16.01 5 17.17 5 18.5C5 20.43 6.57 22 8.5 22C10.26 22 11.72 20.7 11.96 19H14.04C14.28 20.7 15.74 22 17.5 22C19.43 22 21 20.43 21 18.5C21 17.46 20.54 16.53 19.82 15.89ZM8.5 20C7.67 20 7 19.33 7 18.5C7 17.67 7.67 17 8.5 17C9.33 17 10 17.67 10 18.5C10 19.33 9.33 20 8.5 20ZM17.5 20C16.67 20 16 19.33 16 18.5C16 17.67 16.67 17 17.5 17C18.33 17 19 17.67 19 18.5C19 19.33 18.33 20 17.5 20Z',
      key: 'tj55f9',
    },
  ],
]);

export default ChildFriendly;
